<template v-bind:class="color" v-html="displayedText">
  <transition name="fade">
    <div v-if="alertCase!=='online' && hidden === false" class="alert-bar" v-bind:class="[alertColorClassMapping[alertCase]]">
      <span class="alert-text">
              {{alertCaseTextMapping[alertCase]}}
      </span>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    color: String,
    alertCase: String,
    displayTimer:Number,
    displayedText: [String, Number]
  },
  data: function () {
    return {
      hideTimer:null,
      hidden:true,
      alertCaseTextMapping: {
        toggleOffBotFailure:this.$t('trader.bettingBot.toggleOffBotFailure'),
        toggleOnBotFailure:this.$t('trader.bettingBot.toggleOnBotFailure'),
        noWsConnection: this.$t('errorMessages.noWsConnection'),
        feedOffline: this.$t('errorMessages.feedOffline'),
        appOffline: this.$t('errorMessages.appOffline'),
        lockdown: this.$t('errorMessages.lockdown')
      },
      alertColorClassMapping:{
        toggleOffBotFailure:'critical-error-alert',
        toggleOnBotFailure:'critical-error-alert',
        noWsConnection:'critical-error-alert',
        feedOffline:'critical-error-alert',
        appOffline:'critical-error-alert',
        lockdown:'critical-error-alert'
      }
    };
  },
  watch:{
    alertCase:function (alertCase){
      if(alertCase === 'toggleOffBotFailure' || alertCase === 'toggleOnBotFailure'){
        this.hidden = false;

        this.hideTimer = setTimeout(function (){
            this.hidden = true;
            this.$store.commit('setAlertMessage',null)
          }.bind(this)
        ,2000)
      } else if(alertCase !=='online'){
        this.hidden = false
        clearTimeout(this.hideTimer)
        this.hideTimer = null;
      }
}
  },
  name: 'kryptAlert'
};
</script>

<style scoped>
  .alert-text {
    width: 100%;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */
    color: inherit;
    font-family: "Open Sans", sans-serif;
    text-align: center;
    padding: 8px;
  }
  .critical-error-alert{
    background: #FEFAFA;
    color: #E51245;

  }
  .positive-alert{

  }
  .warning-alert{

  }
  .info-alert{

  }
  .alert-bar{
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0;
    z-index: 100; /* to make it appear above the text of of inactive overlays */
    height: max-content;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fade-enter-active, .fade-leave-active {
    transition: all 0.4s;
  }
  .fade-enter, .fade-leave-to {
    transform: translateY(-100%);
  }

  /*Media Queries*/

  @media screen and (min-width: 1500px){
    .alert-bar{
      margin-left: 256px !important;
    }
  }

  @media screen and (min-width: 1280px){
    .alert-bar{
      margin-right: 360px !important;
    }
  }

</style>
